// extracted by mini-css-extract-plugin
export default {"card":"HeroPage_card__ZSWpJ"};